import { Typography } from "@mui/material";

const CustomersStageStatus = ({ ...props }) => {
  const record = props.record;
  const userType = record.userType;
  const userId = props.userId;
  let customerBgColor = "#00000014";
  let customerStage = "";
  let customerStageStatus = "";

  if (userType == "signUp2026_campaigns") {
    customerStage = "Sign-Ups in 2026 to Date";
    customerStageStatus = "Campaigns";
  } else if (userType == "signUp2026_counselors") {
    customerStage = "Sign-Ups in 2026 to Date";
    customerStageStatus = "Counselors";
  } else if (userType == "signUp2026_direct") {
    customerStage = "Sign-Ups in 2026 to Date";
    customerStageStatus = "Direct";
  } else if (userType == "signUp2026_other") {
    customerStage = "Sign-Ups in 2026 to Date";
    customerStageStatus = "Other";
  } else if (userType == "signUp2025_campaigns") {
    customerStage = "Sign-Ups in 2025 to Date";
    customerStageStatus = "Campaigns";
  } else if (userType == "signUp2025_counselors") {
    customerStage = "Sign-Ups in 2025 to Date";
    customerStageStatus = "Counselors";
  } else if (userType == "signUp2025_direct") {
    customerStage = "Sign-Ups in 2025 to Date";
    customerStageStatus = "Direct";
  } else if (userType == "signUp2025_other") {
    customerStage = "Sign-Ups in 2025 to Date";
    customerStageStatus = "Other";
  } else if (userType == "signUp2024_campaigns") {
    customerStage = "Sign-Ups in 2024 to Date";
    customerStageStatus = "Campaigns";
  } else if (userType == "signUp2024_counselors") {
    customerStage = "Sign-Ups in 2024 to Date";
    customerStageStatus = "Counselors";
  } else if (userType == "signUp2024_direct") {
    customerStage = "Sign-Ups in 2024 to Date";
    customerStageStatus = "Direct";
  } else if (userType == "signUp2024_other") {
    customerStage = "Sign-Ups in 2024 to Date";
    customerStageStatus = "Other";
  } else if (userType == "signUp2023_campaigns") {
    customerStage = "Sign-Ups in 2023 to Date";
    customerStageStatus = "Campaigns";
  } else if (userType == "signUp2023_counselors") {
    customerStage = "Sign-Ups in 2023 to Date";
    customerStageStatus = "Counselors";
  } else if (userType == "signUp2023_direct") {
    customerStage = "Sign-Ups in 2023 to Date";
    customerStageStatus = "Direct";
  } else if (userType == "signUp2023_other") {
    customerStage = "Sign-Ups in 2023 to Date";
    customerStageStatus = "Other";
  }
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        mb: 1,
        fontWeight: "bold",
        backgroundColor: customerBgColor || "#fff3cd",
        color:
          customerBgColor == "#00000014" || customerBgColor == "#fff1da"
            ? "black"
            : "white",
        p: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "60px",
      }}
    >
      {/* ---{userId}---{userType} */}
      {customerStage}
      {customerStageStatus ? (
        <>
          <br />
          {customerStageStatus}
        </>
      ) : (
        ""
      )}
    </Typography>
  );
};

export default CustomersStageStatus;
